import { APPOINTMENT_STATUSES } from 'features/order-tracker/utils/entries';
import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class MissedAppointmentStrategy implements AppointmentStrategy {
  
  getInfoType = (): common.ContactUsInfo => CONTACT_US_INFO_TYPE.Missed;

  isReminderAvailable = (): boolean => false;

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (): boolean => false;

  isApplicable = (appointment: common.EngineerAppointment): boolean =>
    appointment.status === APPOINTMENT_STATUSES.CustomerMissed ||
    appointment.status === APPOINTMENT_STATUSES.ReAppointEUMissed;

  isHelpSectionAvailable = (): boolean => false;
}
